import axios from "axios";

const instance = axios.create({
  baseURL: process.env.SLOT_API_URL,
});

instance.interceptors.request.use(
  (config) => {
    if (window.localStorage.getItem("accessToken"))
      config.headers.Authorization = `Bearer ${window.localStorage.getItem(
        "accessToken"
      )}`;
    return config;
  },
  (error) => Promise.reject(error)
);
instance.interceptors.response.use(
  (config) => config,
  async (error) => {
    if (error.response.status === 401) {
      try {
        const response = await instance.put(
          `auth/refresh`,
          {
            refreshToken: window.localStorage.getItem("refreshToken"),
            platform: "WEB",
          },
          {
            headers: {
              "x-app-version": "v1",
            },
          }
        );

        window.localStorage.setItem("accessToken", response.data.token);
        window.localStorage.setItem("refreshToken", response.data.refreshToken);

        error.config.headers["Authorization"] = `Bearer ${response.data.token}`;

        return axios(error.config);
      } catch (err) {
        // window.location.reload();
        console.log(err);
      }
    } else {
      if (error.response.status > 403) return undefined;
      console.error(error.response);
    }
    return Promise.reject(error);
  }
);

export default instance;
